module.exports = __webpack_public_path__ + "static/img/h5-gift-en.da98c867.png";